(function (ws) {
    'use strict';
    ws.models.addMandatoryProducts = Backbone.Model.extend({

        defaults: {
            mainProductList: []
        },

        url: function() {
            return globals.path.api.westcon.addAssociatedProduct;
        }
    });
})(westcon);
